import {AuthAccountStates} from './store-models/account.model';

export interface SptFirebaseConnectionService<T> {
  onConnect(user: AuthAccountStates): void;
  onDisconnect(user: AuthAccountStates): void;
}
